<script setup lang="ts">
/**
 * Portal App Root Component
 */
import { onMounted } from 'vue'
import { useAuthStore, useUIStore, MermaidZoom, ToastBridge } from '@claimshield/shared'

const authStore = useAuthStore()
const uiStore = useUIStore()

onMounted(async () => {
  // Initialize UI (theme, sidebar state)
  uiStore.initialize()
  // Initialize auth
  await authStore.initialize()
})
</script>

<template>
  <PToast position="top-right" :baseZIndex="9999" />
  <ToastBridge />
  <MermaidZoom />
  <RouterView />
</template>
